import React, { Component } from 'react';
import { func, object, bool, string } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import _isEmpty from 'lodash/isEmpty';
import clsx from 'clsx';
import Spinner from '../../../../components/LazyWidgets/Spinner';
import s from '../overviewWidget.module.css';
import MLButton from '../../../../components/MLButton';
import sButton from '../../../../components/MLButton/MLButton.module.css';
import MLToolLaunchLink from '../../../components/MLToolLaunchLink';
import { sendAnalyticsEvent } from '../../../actions/reports';
import { VIEW_NEW_INSIGHTS_WIDGET } from '../../../analyticsEvents';

class QQOverviewWidget extends Component {
  static propTypes = {
    sendAnalytics: func,
    onTabChange: func,
    data: object,
    loading: bool,
    shortId: string,
    getLaunchUrl: func,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const newData = {};
    if (nextProps.loading !== prevState.loading) {
      newData.loading = nextProps.loading;
    }
    if (nextProps.data !== prevState.data) {
      newData.data = nextProps.data;
      newData.activeUnit = nextProps.data ? nextProps.data.activeUnit : null;
      newData.lowScoringStudents = nextProps.data
        ? nextProps.data.lowScoringStudents
        : 0;
      newData.lowScoringAssignment = nextProps.data
        ? nextProps.data.lowScoringAssignment
        : null;
    }
    return _isEmpty(newData) ? null : newData;
  }

  constructor(props) {
    super(props);
    this.state = {
      data: props.data,
      loading: props.loading,
      activeUnit: props.data ? props.data.activeUnit : null,
      lowScoringStudents: props.data ? props.data.lowScoringStudents : 0,
      lowScoringAssignment: props.data ? props.data.lowScoringAssignment : null,
    };
  }

  componentDidMount() {
    this.props.sendAnalytics(VIEW_NEW_INSIGHTS_WIDGET);
  }

  render() {
    const {
      loading,
      activeUnit,
      lowScoringStudents,
      lowScoringAssignment,
    } = this.state;

    const { onTabChange } = this.props;

    const lowScoringAssignmentMutate =
      lowScoringAssignment && this.props
        ? {
            id: lowScoringAssignment.id,
            course_id: lowScoringAssignment.courseId,
            tool: lowScoringAssignment.tool,
            activity_id: lowScoringAssignment.activityId,
            short_id: this.props.shortId,
          }
        : {};

    if (loading) {
      return (
        <div className={`${s.OverviewCard} ${s.QQOverviewCard}`}>
          <Spinner className={s.spinner} />
        </div>
      );
    }

    const correctOnFirstTryPercentage = Math.round(
      activeUnit.correctOnFirstTry * 100
    );

    return (
      activeUnit && (
        <>
          {activeUnit.correctOnFirstTry > 0 && (
            <div className={s.OverviewSection}>
              <div className={s.titleText}>
                How is my class performing in the current unit?
              </div>
              <div className={s.cftSection}>
                <span className={s.percentage}>
                  {correctOnFirstTryPercentage}%
                </span>
                <span className={s.greyText}>
                  Questions answered correctly on their first try
                </span>
                <div className={s.buttonContainer}>
                  <MLButton
                    ariaLabel="View Unit Report"
                    btnText="View Unit Report"
                    className={clsx(s.viewBtn, sButton.btnSecondary)}
                    onClick={() => {
                      onTabChange(`reports/type/unit/${activeUnit.id}`);
                    }}
                    testId="btn_view_unit_report"
                  />
                </div>
              </div>
            </div>
          )}
          {lowScoringStudents > 0 && (
            <div className={s.OverviewSection}>
              <div className={s.titleText}>
                How many students have low scores in the current unit?
              </div>
              <div className={s.lowScoreSection}>
                <span
                  className={clsx(s.percentage, s.lowScoring)}
                >{`${lowScoringStudents} student${
                  lowScoringStudents === 1 ? '' : 's'
                }`}</span>
                <span className={`${s.greyText}`}>
                  Scored below 60% on proficiency assignments
                </span>
                <div className={s.buttonContainer}>
                  <MLButton
                    ariaLabel={
                      lowScoringStudents === 1
                        ? 'View Student'
                        : 'View Students'
                    }
                    btnText={
                      lowScoringStudents === 1
                        ? 'View Student'
                        : 'View Students'
                    }
                    className={clsx(s.viewBtn, sButton.btnSecondary)}
                    onClick={() => {
                      onTabChange(
                        `reports/type/unit/${activeUnit.id}#studentsListCard`
                      );
                    }}
                    testId="btn_view"
                  />
                </div>
              </div>
            </div>
          )}
          {lowScoringAssignment && (
            <div className={s.OverviewSection}>
              <div className={s.titleText}>
                Which assignment is causing the most trouble?
              </div>
              <div>
                <MLToolLaunchLink
                  className={s.viewLink}
                  testId="insights_widget_assignment_most_trouble"
                  data={{ ...lowScoringAssignmentMutate }}
                  linkLabel={lowScoringAssignment.name}
                  getLaunchUrl={this.props.getLaunchUrl}
                />
              </div>
            </div>
          )}
        </>
      )
    );
  }
}

function mapStateToProps(state) {
  return {
    backPages: state.backPages,
  };
}
const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ sendAnalytics: sendAnalyticsEvent }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  QQOverviewWidget
);
